import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';

export default function Word(props) {

   const location = useLocation();
   const [id, setId] = useState(props.id ? props.id :new URLSearchParams(location.search).get('id'));
   const [data, setData] = useState([]);
   const [lastClicked , setLastCliked] = useState(0);
   const [lastAdded, setLastAdded] = useState(0);
   const [currentWordIndex , setcurrentWordIndex] = useState(0);
   const [letters , setLetters] = useState([]);
   const [lettersChosen , setLettersChosen] = useState([]);
   const [rightLetters , setRightLetters] = useState([]);
   const [selectedIndex, setSelectedIndex] = useState([]);
   const [selectedItems, setSelectedItems] = useState([]);
   const [selectedFirsIndex, setSelectedFirsIndex] = useState([]);
   const [finished, setFinished] = useState(0);

  useEffect(()=>{
   getData();
  },[id])

  useEffect(()=>{
   if(data && data[currentWordIndex]?.value){
      let arr = data[currentWordIndex].value.split("");
      let arrChufled = data[currentWordIndex].value.split("");
      setRightLetters( arr );
   //   console.log(arr);
      setLetters(shuffleArray( arrChufled ) );
      
      setLettersChosen(Array.from({ length: arr.length }))

      setSelectedIndex([]);
      setSelectedItems([]);
     setSelectedFirsIndex([]);
     setFinished(0);
   }
   
  },[data,currentWordIndex])

   const getData = () => {
      axios.get("/appi/table/grid/"+id, { withCredentials: true })
      .then(response => {
       //  console.log(response.data);
         setData(response.data);
      })
      .catch(error => {});
   }


   const handleClick = (index) => {
    
      if(!selectedFirsIndex.includes(index)){
         setLastCliked(index);
     
         const item =letters[index]; 
         setSelectedFirsIndex((prev) =>
          prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
        );
         let added = 0;
         lettersChosen.forEach((it,index)=>{
          if(!it && added === 0){
             lettersChosen[index] = item;
             added = 1;
             setSelectedIndex((prev) =>
                prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
              );
             
          }
         })
       
        setLettersChosen( lettersChosen );
        selectedItems.push(item)
        setSelectedItems(selectedItems);
    
        if(arraysAreEqual(rightLetters,selectedItems)) {
          setFinished(1);
        }
      }
    
  
   };
   const arraysAreEqual = (arr1, arr2) =>{
      return JSON.stringify(arr1) === JSON.stringify(arr2);
    }
   const shuffleArray =(array)=> {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1)); // Losowy indeks od 0 do i
        [array[i], array[j]] = [array[j], array[i]]; // Zamiana miejscami elementów
      }
      return array;
    }

    const compare=(firs,sec)=>{
      if(firs === sec){
         return true;
      } else{
         return false;
      }
    }

    const isCliked=(item)=>{
     
     if(item){
         if( selectedItems.includes( item )){
            console.log("cliked "+item)
         console.log(selectedFirsIndex);
            return true;
         }
      }else{
         return false;
      }
      
    }

    const handleReverseClick = (index) => {
  
      if(selectedIndex.includes(index)){
         setLastCliked(index);
     
         const item =lettersChosen[index]; // Usuwa element z tablicy i zwraca go
      //    setSelectedIndex((prev) =>
      //     prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
      //   );

        let i = index;

         const itemFirstRow = letters.findIndex(obj => obj === item); 

         setSelectedFirsIndex( selectedFirsIndex.filter(num => num !== itemFirstRow) ) ;
         setSelectedIndex( selectedIndex.filter(num => num !== index) ) ;
         let added = 1;
         lettersChosen.forEach((it,index)=>{
          if(it && added === 1 && index === i){
             lettersChosen[index] = null;
             added = 0;
            //  setSelectedIndex((prev) =>
            //     prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
            //   );
             
          }
         })
        
        
       // handleBack();
        setSelectedItems( selectedItems.filter(( selected ,index ) => selected !== item && index !== i) );
        setLettersChosen( lettersChosen );
       //  lettersChosen.splice(item,1);
       console.log("---------!+++++");
        console.log(selectedIndex);
        console.log(selectedIndex.filter(num => num !== index) );
        console.log("---------!______");
        console.log(selectedItems.filter(( selected ,index ) => selected !== item && index !== i) );
      }
    }

    const handleNext = () => {
      //alert(data.length);
      if(data.length > currentWordIndex+1){
         setcurrentWordIndex(currentWordIndex+1);
         //alert('asdas');
      }
       
    }
  
  return (
    <div style={{width: '100%',minHeight:'100vh',display:'flex',flexDirection:'column', justifyContent:'center'}}>
     

      <div className='row-container'>
      
         {
            Array.isArray(letters) ?
            Object.values( letters.map( (item, index) => (
                     <div key={index} 
                     className={`word-set-card ${selectedFirsIndex.includes(index) ? "flipped" : ""}`} 
                     onClick={(e) =>handleClick(index) }>
                        <div className="word-card-inner " style={{animation: `start 0.3s ${index/25}s forwards`}}>
                           <div className="word-card-front">
                              <p className='card-front-txt'>{item}</p>
                           </div>
                           <div className="word-card-back">
                           <p style={{margin:10, color:'white', fontSize:30}}>{item}</p>
                           </div>
                        </div>
                        
                     </div>
           )))
           : "Empty list"
            
         }
      </div>
      <div>
         <div className='btn-right' style={{display: data.length >1 && data.length > currentWordIndex +1 ? 'block': 'none'}} onClick={(e)=>handleNext()}>
            
         </div>
      </div>
      <div className='row-container'>
      {
            Array.isArray(lettersChosen) ?
            Object.values( lettersChosen.map( (item, index) => (
                     <div key={index} 
                     className="word-set-card" 
                     onClick={(e) =>handleReverseClick(index) }>
                        <div className={` word-card-inner ${selectedIndex.includes(index) ? "flipped" : "cover"} `} 
                        style={{ animation: finished===1 ? `finish 0.3s ${index/25}s forwards`: 'none'}}
                        >
                           <div className="word-card-front" 
                           style={{ background: isCliked(item)  ?  (compare(item,rightLetters[index])  ) ? ('rgb(47, 121, 51)'):('rgb(218, 51, 29)') : 'transparent' }}>
                              <p className='card-front-txt' style={{color:'white'}}>{item}</p>
                           </div>
                           <div className="word-card-back">
                           <p style={{margin:10, color:'white', fontSize:30}}>{item}</p>
                           </div>
                        </div>
                        
                     </div>
           )))
           : "Empty list"
            
         }
      </div>
    </div>
  )
}
